export default __webpack_public_path__ + "static/media/icon_Text_Type.d81631a4.svg";